export const DISALLOWED_DOMAINS = [
  "aol.com",
  "comcast.net",
  "gmail.com",
  "googlemail.com",
  "hotmail.com",
  "icloud.com",
  "msn.com",
  "outlook.com",
  "yahoo.com",
];
